import QuestionsDropdownPage from '../b2b/QuestionsDropdownPage';

const Faq = () => {
  return <QuestionsDropdownPage />;
};

export default Faq;
